export const IST_TIME_ZONE = "Asia/Kolkata";

export const formatIstTime = (value) => {
  if (!value) return "-";
  return new Date(value).toLocaleTimeString("en-IN", {
    timeZone: IST_TIME_ZONE,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

export const formatIstDateTime = (value) => {
  if (!value) return "-";
  return new Date(value).toLocaleString("en-IN", {
    timeZone: IST_TIME_ZONE,
    dateStyle: "medium",
    timeStyle: "short",
  });
};

export const formatIstDate = (value) => {
  if (!value) return "-";
  return new Date(value).toLocaleDateString("en-IN", { timeZone: IST_TIME_ZONE });
};

export const todayYmdIST = () => {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: IST_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(new Date());
  const out = {};
  parts.forEach((p) => {
    if (p.type !== "literal") out[p.type] = p.value;
  });
  return `${out.year}-${out.month}-${out.day}`;
};

export const addDaysToYmd = (ymd, days) => {
  const [y, m, d] = String(ymd).split("-").map((n) => parseInt(n, 10));
  if (!y || !m || !d) return ymd;
  const dt = new Date(Date.UTC(y, m - 1, d));
  dt.setUTCDate(dt.getUTCDate() + days);
  return `${dt.getUTCFullYear()}-${String(dt.getUTCMonth() + 1).padStart(2, "0")}-${String(dt.getUTCDate()).padStart(2, "0")}`;
};

export const previousYmdIST = () => addDaysToYmd(todayYmdIST(), -1);

export const periodStartIstMs = (period = "day") => {
  const today = todayYmdIST();
  const [y, m, d] = today.split("-").map((n) => parseInt(n, 10));
  if (!y || !m || !d) return Date.now();
  if (period === "year") return new Date(`${y}-01-01T00:00:00+05:30`).getTime();
  if (period === "month") return new Date(`${y}-${String(m).padStart(2, "0")}-01T00:00:00+05:30`).getTime();
  if (period === "week") {
    const utcNoon = new Date(Date.UTC(y, m - 1, d, 12));
    const day = utcNoon.getUTCDay() || 7;
    return new Date(`${addDaysToYmd(today, 1 - day)}T00:00:00+05:30`).getTime();
  }
  return new Date(`${today}T00:00:00+05:30`).getTime();
};

export const periodRangeIst = (period = "day", value) => {
  const today = todayYmdIST();
  const selected = value || (period === "month" ? today.slice(0, 7) : period === "year" ? today.slice(0, 4) : today);
  if (period === "since") {
    const from = String(selected || today).slice(0, 10);
    return {
      start: new Date(`${from}T00:00:00+05:30`).getTime(),
      end: Date.now() + 1,
      label: `${from} to present`,
      includesPresent: true,
    };
  }
  if (period === "custom") {
    const rawFrom = String(value?.fromDate || today).slice(0, 10);
    const rawTo = String(value?.toDate || today).slice(0, 10);
    const from = rawFrom <= rawTo ? rawFrom : rawTo;
    const to = rawFrom <= rawTo ? rawTo : rawFrom;
    return {
      start: new Date(`${from}T00:00:00+05:30`).getTime(),
      end: new Date(`${addDaysToYmd(to, 1)}T00:00:00+05:30`).getTime(),
      label: `${from} to ${to}`,
      includesPresent: to >= today,
    };
  }
  if (period === "year") {
    const year = String(selected).slice(0, 4);
    return {
      start: new Date(`${year}-01-01T00:00:00+05:30`).getTime(),
      end: new Date(`${Number(year) + 1}-01-01T00:00:00+05:30`).getTime(),
      label: year,
    };
  }
  if (period === "month") {
    const [year, month] = String(selected).split("-").map((n) => parseInt(n, 10));
    const startYmd = `${year}-${String(month).padStart(2, "0")}-01`;
    const nextMonth = month === 12 ? { year: year + 1, month: 1 } : { year, month: month + 1 };
    const endYmd = `${nextMonth.year}-${String(nextMonth.month).padStart(2, "0")}-01`;
    return {
      start: new Date(`${startYmd}T00:00:00+05:30`).getTime(),
      end: new Date(`${endYmd}T00:00:00+05:30`).getTime(),
      label: startYmd.slice(0, 7),
    };
  }
  if (period === "week") {
    const weekStart = String(selected);
    const weekEnd = addDaysToYmd(weekStart, 7);
    return {
      start: new Date(`${weekStart}T00:00:00+05:30`).getTime(),
      end: new Date(`${weekEnd}T00:00:00+05:30`).getTime(),
      label: `${weekStart} to ${addDaysToYmd(weekStart, 6)}`,
    };
  }
  return {
    start: new Date(`${selected}T00:00:00+05:30`).getTime(),
    end: new Date(`${addDaysToYmd(selected, 1)}T00:00:00+05:30`).getTime(),
    label: selected,
  };
};

export const currentPeriodValueIST = (period = "day") => {
  const today = todayYmdIST();
  if (period === "since" || period === "custom") return today;
  if (period === "year") return today.slice(0, 4);
  if (period === "month") return today.slice(0, 7);
  if (period === "week") {
    const [y, m, d] = today.split("-").map((n) => parseInt(n, 10));
    const utcNoon = new Date(Date.UTC(y, m - 1, d, 12));
    const day = utcNoon.getUTCDay() || 7;
    return addDaysToYmd(today, 1 - day);
  }
  return today;
};
